<app-header></app-header>

<bit-container>
  <p>{{ "newOrganizationDesc" | vfo1I18n: "addPlanDesc" }}</p>
  <app-organization-plans
    [enableSecretsManagerByDefault]="secretsManager"
    [initialPlan]="plan"
    [initialProductTier]="productTier"
    [trialLength]="trialLength"
    [initiationPath]="initiationPath"
  ></app-organization-plans>
</bit-container>
